// extracted by mini-css-extract-plugin
export default {"loader":"OrderStepSelectProdParams_loader__5E5Qt","orderProps":"OrderStepSelectProdParams_orderProps__1b1BM","orderPropsWrapper":"OrderStepSelectProdParams_orderPropsWrapper__KTJdd"};